import { render, staticRenderFns } from "./sectionIndicator.vue?vue&type=template&id=238f2326&scoped=true&lang=pug&"
import script from "./sectionIndicator.vue?vue&type=script&lang=js&"
export * from "./sectionIndicator.vue?vue&type=script&lang=js&"
import style0 from "./sectionIndicator.vue?vue&type=style&index=0&id=238f2326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f2326",
  null
  
)

export default component.exports